// This function is used to show toast message when network error occurs
import { handleErrorToast } from "@/UI/Toasts";

// eg. handleNetworkError({message: error.response});
const handleNetworkError = (response: any) => {
  if (response.status == 500) {
    handleErrorToast({
      message: response.statusText || "Internal Server Error!",
    });
  } else {
    handleErrorToast({
      message: response.data.message || "Something went wrong",
    });
  }
};

export { handleNetworkError };
